export default __webpack_public_path__ + "static/media/hearing.d79ec159.webp";